import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState } from 'react';

// Core pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

// Learn & Earn pages
import LearnEarnPage from './pages/LearnEarnPage';
import CustomerWorkPage from './pages/CustomerWorkPage';
import SubscriptionServicePage from './pages/SubscriptionServicePage';
import SubscriptionDashboardPage from './pages/SubscriptionDashboardPage';
import OTSServicePage from './pages/OTSServicePage';
import WorkshopPage from './pages/WorkshopPage';
import CurriculumPage from './pages/CurriculumPage';
import PricingPolicyPage from './pages/PricingPolicyPage';

// Finance pages
import FinanceLandingPage from './pages/FinanceLandingPage';
import FinancePage from './pages/FinancePage';
import LifeInsurancePage from './pages/LifeInsurancePage';
import HealthInsurancePage from './pages/HealthInsurancePage';
import CarInsurancePage from './pages/CarInsurancePage';
import InvestmentPlansPage from './pages/InvestmentPlansPage';
import MutualFundsPage from './pages/MutualFundsPage';

// SEO Landing pages — Student Services
import AssignmentWritingPage from './pages/AssignmentWritingPage';
import JournalWritingPage from './pages/JournalWritingPage';
import CollegeProjectPage from './pages/CollegeProjectPage';
import SchoolProjectPage from './pages/SchoolProjectPage';
import StudentJobsPage from './pages/StudentJobsPage';

// Location pages
import LocationPage from './pages/LocationPage';

// Blog
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';

// Layout
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import ScrollToTop from './components/Layout/ScrollToTop';

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const [activeSection, setActiveSection] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <ScrollToTop />
      <Navbar
        setActiveSection={setActiveSection}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <main>
        <Routes>
          {/* ── Core Routes ─────────────────────────────────── */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* ── Finance Routes ───────────────────────────────── */}
          <Route path="/finance" element={<FinanceLandingPage />} />
          <Route path="/finance/insurance" element={<FinancePage />} />
          <Route path="/finance/life-insurance" element={<LifeInsurancePage />} />
          <Route path="/finance/health-insurance" element={<HealthInsurancePage />} />
          <Route path="/finance/car-insurance" element={<CarInsurancePage />} />
          <Route path="/finance/investment-plans" element={<InvestmentPlansPage />} />
          <Route path="/finance/mutual-funds" element={<MutualFundsPage />} />

          {/* ── Learn & Earn Routes ──────────────────────────── */}
          <Route path="/learn" element={<LearnEarnPage />} />
          <Route path="/learn-and-earn" element={<LearnEarnPage />} />
          <Route path="/learn/customer-work" element={<CustomerWorkPage />} />
          <Route path="/learn/customer-work/subscription" element={<SubscriptionServicePage />} />
          <Route path="/learn/customer-work/ots" element={<OTSServicePage />} />
          <Route path="/learn/workshop" element={<WorkshopPage />} />
          <Route path="/learn/curriculum" element={<CurriculumPage />} />

          {/* ── Subscription Dashboard ───────────────────────── */}
          <Route path="/subscription/dashboard" element={<SubscriptionDashboardPage />} />

          {/* ── SEO Landing Pages — Student Services ────────── */}
          <Route path="/assignment-writing-service" element={<AssignmentWritingPage />} />
          <Route path="/journal-writing-service" element={<JournalWritingPage />} />
          <Route path="/college-project-help" element={<CollegeProjectPage />} />
          <Route path="/school-project-help" element={<SchoolProjectPage />} />
          <Route path="/student-jobs-earn-money" element={<StudentJobsPage />} />

          {/* ── Location Pages — Assignment Help ─────────────── */}
          <Route path="/assignment-help-mumbai" element={<LocationPage slug="assignment-help-mumbai" />} />
          <Route path="/assignment-help-pune" element={<LocationPage slug="assignment-help-pune" />} />
          <Route path="/assignment-help-navi-mumbai" element={<LocationPage slug="assignment-help-navi-mumbai" />} />
          <Route path="/assignment-help-thane" element={<LocationPage slug="assignment-help-thane" />} />
          <Route path="/assignment-help-kalyan" element={<LocationPage slug="assignment-help-kalyan" />} />

          {/* ── Location Pages — Insurance ───────────────────── */}
          <Route path="/insurance-services-mumbai" element={<LocationPage slug="insurance-services-mumbai" />} />
          <Route path="/insurance-services-pune" element={<LocationPage slug="insurance-services-pune" />} />

          {/* ── Blog ─────────────────────────────────────────── */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />

          {/* ── Policies ─────────────────────────────────────── */}
          <Route path="/pricing-policy" element={<PricingPolicyPage />} />

          {/* ── Fallback ─────────────────────────────────────── */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer setActiveSection={setActiveSection} />
    </div>
  );
}

export default App;
